import { Badge } from './Badge'
import { useGetAllUnclaimedVouchers } from '../privileges/Vouchers'

export const VouchersCount = () => {
    const { loading, unclaimedVouchers } = useGetAllUnclaimedVouchers()
    return !loading && unclaimedVouchers.length ? (
        <Badge>{unclaimedVouchers.length}</Badge>
    ) : null
}
